<template>
  <div class="flex h-dvh flex-col" :style="styles">
    <div
      class="w-full min-h-[50px] tablet-h:min-h-[60px] flex items-center justify-center font-secondary relative"
    >
      <BackButton
        v-if="showBackButton"
        class="absolute left-3 top-1/2 -translate-y-1/2"
        @click="onboardingStore.goToPrevStep"
      />

      <DacrWordLogo class="h-[26px] desktop:h-[30px]" />
    </div>

    <div class="relative flex h-full min-h-0 flex-1 overflow-hidden">
      <RouterView class="w-full overflow-auto" :style="routerStyles" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import { computed, watchEffect } from 'vue'
import { useDevice } from '@/shared/composables/useDevice'
import BackButton from '@/shared/components/BackButton.vue'
import { useOnboardingStore } from '@/features/onboarding/store'
import { useRoute, useRouter } from 'vue-router'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'
import {
  useOnboardingQuery,
  usePlansQueryQuery,
} from '@/shared/graphql/legacy/generated'
import { getTokens } from '@dacr/auth'

const _ = usePlansQueryQuery({ accessToken: getTokens().accessToken })

const { result } = useOnboardingQuery()

const device = useDevice()
const router = useRouter()
const route = useRoute()
const onboardingStore = useOnboardingStore()
const webviewStore = useWebviewStore()

watchEffect(() => {
  if (!result.value?.onboarding.completed) return

  if (webviewStore.isActive) {
    return webviewStore.postMessage({
      type: NativeActionsEnum.NavigationHome,
    })
  }

  router.push('/home')
})

const styles = computed(() => ({
  ...(webviewStore.isActive && {
    height: `${device.viewportHeight.value}px`,
    paddingTop: `${webviewStore.topSafeAreaHeight}px`,
  }),
}))

const isCheckout = computed(() => route.path === '/onboarding/checkout')
const isSteps = computed(() => route.path === '/onboarding')

const bottomClearance = computed(() => {
  if (webviewStore.isActive) return 22 + webviewStore.bottomSafeAreaHeight
  if (isCheckout.value) return null

  return device.isDesktopLayout.value ? 70 : 22
})

const routerStyles = computed(() => ({
  ...(bottomClearance.value !== null && {
    paddingBottom: `${bottomClearance.value}px`,
  }),
}))

const showBackButton = computed(() => onboardingStore.step > 1 && isSteps.value)
</script>
